import Planet from "~/assets/images/Planet.png";

type BlueHeroProps = {
  title: string;
  subtext: string;
  date? : string
}

export function BlueHero({title, subtext, date} : BlueHeroProps) {
  return (
    <div className="flex h-[50vh] relative overflow-hidden gap-10 rounded-bl-[32px] rounded-br-[32px] bg-[#2D2F35] px-4 py-16 text-[#E9E9E9] sm:rounded-bl-[80px] sm:rounded-br-[80px] sm:px-[5%] sm:py-[7%] md:min-h-[60vh] items-start justify-start lg:flex-row lg:gap-0">
      <div className="z-[3] my-[3%] flex w-full flex-col sm:mt-[20%] items-start justify-start lg:mt-[8%] lg:w-[48%]">
        <div className="mb-[24px] mt-20 w-full sm:mb-[32px] sm:w-[90%] md:mt-0">
          <h2 className="mb-[20px] mt-[14px] font-inter text-[40px] font-bold leading-10 text-white sm:w-11/12 sm:text-[40px] sm:leading-9 md:text-start lg:w-auto lg:text-[48px] xl:text-[64px] xl:leading-[69px]">
            {title}
          </h2>
          <p className="xs:text-sm mb-4 text-nowrap text-[14px] font-medium text-[rgba(255,255,255,0.74)] sm:mb-6 sm:w-10/12 sm:text-xl md:text-start lg:w-auto">
            {subtext}: <span className="text-white">{date}</span>
          </p>
        </div>
      </div>
      <div className="absolute inset-0 z-10">
        <img src={Planet} alt="blur" className="w-full h-full object-cover" />
      </div>
    </div>
  );
}
